import { FormModal, FormModalType, InputField, noop, useToast } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Cohort } from '../../models';
import { addCohort, modifyCohort, removeCohort } from '../../redux/actions';

export function CohortModal(props) {
  const { cohort = undefined, onClose = noop, onSuccess = noop, visible = false } = props;

  // VARIABLES
  const defaultValues = {
    displayName: cohort?.displayName,
  };

  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.cohortsReducer.cohortAction);
  // Custom
  const { showErrorToast, showSuccessToast } = useToast();

  const fields = [
    new InputField({
      id: 'displayName',
      label: 'Name',
      maxLength: 250,
      required: true,
      value: defaultValues.displayName,
    }),
  ];

  const onCreate = (data) => {
    dispatch(
      addCohort({
        cohortData: data,
        onSuccess: () => {
          showSuccessToast('Cohort created successfully');
          onSuccess();
        },
        onError: showErrorToast,
      }),
    );
  };

  const onUpdate = (data) => {
    dispatch(
      modifyCohort({
        id: cohort.id,
        cohortData: data,
        onSuccess: () => {
          showSuccessToast('Cohort updated successfully');
          onSuccess();
        },
        onError: showErrorToast,
      }),
    );
  };

  const onDelete = async () => {
    dispatch(
      removeCohort({
        id: cohort.id,
        onSuccess: () => {
          showSuccessToast('Cohort removed successfully');
          onSuccess();
        },
        onError: showErrorToast,
      }),
    );
  };

  return (
    <FormModal
      defaultValues={defaultValues}
      deletable={Boolean(cohort)}
      fields={fields}
      loading={loading}
      onClose={onClose}
      onCreate={onCreate}
      onDelete={onDelete}
      onUpdate={onUpdate}
      title={cohort ? 'Update Cohort' : 'Add Cohort'}
      type={cohort ? FormModalType.UPDATE : FormModalType.CREATE}
      visible={visible}
    />
  );
}

CohortModal.propTypes = {
  cohort: PropTypes.instanceOf(Cohort),
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool,
};

export default CohortModal;
